import {ChevronDownIcon, ChevronUpIcon, Divider} from 'native-base';
import {
  DriverItem,
  RunInfo,
} from '../../../../../src/driver/types/orderDetails';
import React, {useCallback} from 'react';

import {Accordian} from '@buncha/components/composites';
import {Box} from '../../../../../src/components/core/view';
import {CustomFlatList} from '../../../../../src/components/core/list';
import ItemCellForDriver from './itemCellForDriver';
import OrderInfoHeader from './orderInfoHeader';
import {StyleSheet} from 'react-native';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface OrderInfoProps {
  runInfo: RunInfo | undefined;
  orderItems: DriverItem[];
}

const OrderInfo: React.FC<OrderInfoProps> = props => {
  const orderItems = props?.orderItems || [];
  const theme = useColorThemeType();
  const renderItem = useCallback((orderItem: {item: DriverItem}) => {
    return <ItemCellForDriver itemInfo={orderItem?.item} />;
  }, []);

  const separator = useCallback(() => <Divider />, []);

  if (!orderItems.length) return <></>;

  return (
    <Box style={styles.parentBox}>
      <Accordian
        header={
          <OrderInfoHeader
            runInfo={props?.runInfo}
            itemCount={orderItems?.length}
          />
        }
        children={
          <CustomFlatList
            renderItem={renderItem}
            data={orderItems}
            ItemSeparatorComponent={separator}
          />
        }
        iconEnable={<ChevronUpIcon color={theme?.text.blue[300]} />}
        iconDisable={<ChevronDownIcon color={theme?.text.blue[300]} />}
      />
    </Box>
  );
};

export default React.memo(OrderInfo);

const styles = StyleSheet.create({
  parentBox: {
    marginVertical: 10,
  },
});
